<script lang="ts">
    import { mdiEmailMultipleOutline, mdiPhoneOutline } from "@mdi/js"
    import Icon from "./Icon.svelte"
    import { onDestroy, onMount } from "svelte"

    const arrowUp =
        "M11.9999 12C11.8579 12 11.7389 11.952 11.6429 11.856C11.5469 11.76 11.4993 11.6413 11.4999 11.5V4.86399L6.67694 9.67999C6.58361 9.77332 6.47294 9.81799 6.34494 9.81399C6.21761 9.80932 6.10428 9.75832 6.00494 9.66099C5.91294 9.57099 5.86694 9.45699 5.86694 9.31899C5.86694 9.18099 5.91361 9.06532 6.00694 8.97199L11.4349 3.54499C11.5216 3.45832 11.6116 3.39732 11.7049 3.36199C11.7983 3.32666 11.8973 3.30899 12.0019 3.30899C12.1066 3.30899 12.2053 3.32666 12.2979 3.36199C12.3906 3.39732 12.4799 3.45832 12.5659 3.54499L18.0119 8.99099C18.1053 9.08166 18.1519 9.19499 18.1519 9.33099C18.1519 9.46699 18.1053 9.58332 18.0119 9.67999C17.9146 9.78999 17.7956 9.84199 17.6549 9.83599C17.5149 9.82932 17.3959 9.77732 17.2979 9.67999L12.4999 4.88299V11.5C12.4999 11.642 12.4519 11.7607 12.3559 11.856C12.2599 11.9513 12.1409 11.9993 11.9989 12M11.9989 17C11.8576 17 11.7389 16.952 11.6429 16.856C11.5469 16.76 11.4993 16.6413 11.4999 16.5V14.5C11.4999 14.358 11.5479 14.2393 11.6439 14.144C11.7399 14.0487 11.8589 14.0007 12.0009 14C12.1429 13.9993 12.2616 14.0473 12.3569 14.144C12.4523 14.2407 12.4999 14.3593 12.4999 14.5V16.5C12.4999 16.642 12.4519 16.7607 12.3559 16.856C12.2599 16.9513 12.1409 16.9993 11.9989 17ZM11.9989 21C11.8576 21 11.7389 20.952 11.6429 20.856C11.5469 20.76 11.4993 20.6413 11.4999 20.5V19.5C11.4999 19.358 11.5479 19.2393 11.6439 19.144C11.7399 19.0487 11.8589 19.0007 12.0009 19C12.1429 18.9993 12.2616 19.0473 12.3569 19.144C12.4523 19.2407 12.4999 19.3593 12.4999 19.5V20.5C12.4999 20.642 12.4519 20.7607 12.3559 20.856C12.2599 20.9513 12.1409 20.9993 11.9989 21Z"

    let showScroll = false

    const checkScroll = () => {
        // Change the visibility of the button based on the scroll position
        showScroll = window.pageYOffset > 200
    }

    const scrollToTop = () => {
        if (typeof window !== "undefined") {
            // Scroll smoothly to the top
            window.scrollTo({ top: 0, behavior: "smooth" })
        }
    }

    onMount(() => {
        if (typeof window !== "undefined") {
            // Attach scroll event listener when component is mounted
            window.addEventListener("scroll", checkScroll)
        }
    })

    onDestroy(() => {
        if (typeof window !== "undefined") {
            // Remove scroll event listener when component is destroyed
            window.removeEventListener("scroll", checkScroll)
        }
    })
</script>

<aside>
    <ul>
        <li>
            <button>
                <span class="icon"> <Icon path="{mdiEmailMultipleOutline}" size="24px" /></span>
                <span class="text"><a href="mailto:kanzlei@rechtec.de"> kanzlei@rechtec.de </a></span>
            </button>
        </li>
        <li>
            <button>
                <span class="icon"> <Icon path="{mdiPhoneOutline}" size="24px" /></span>
                <span class="text">0361 - 789 298 65</span>
            </button>
        </li>
    </ul>
    <button
        style="max-width: 36px;"
        on:click="{() => {
            scrollToTop()
        }}"
        class:hide="{!showScroll}"
    >
        <Icon path="{arrowUp}" size="24px" />
    </button>
</aside>

<style lang="less">
    @import "../../css/variables.less";
    aside {
        position: fixed;
        z-index: 9999;
        right: 48px;
        height: calc(50vh - 48px);
        top: 50vh;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;

        button {
            min-width: 36px;
            color: var(--bg-grey-100);
            height: 36px;
            background-color: var(--grey-100);
            border-radius: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: background-color 0.3s;
            border: none;
            &:hover {
                background-color: var(--orange-100);
            }
            &.hide {
                display: none;
            }
        }
        ul {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 12px;
            @media @mobile {
                opacity: 0;
                pointer-events: none;
            }
            button {
                .text {
                    transition: width 1s;
                    width: 0px;
                    height: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    color: var(--bg-grey-100);
                    height: 100%;
                    a {
                        color: var(--bg-grey-100);
                    }
                    a {
                        white-space: nowrap;
                    }
                }
                &:hover {
                    gap: 10px;

                    .text {
                        width: 120px;
                    }
                }
            }
        }
    }
</style>
